<div class="bc-bar">
  <ng-container *ngFor="let crumb of crumbs; let last = last; let first = first">
    <span class="bc-sep" *ngIf="!first">/</span>
    <span
      class="bc-crumb"
      [class.bc-crumb-active]="last"
      [class.bc-crumb-link]="!last && crumb.path"
      (click)="!last && crumb.path ? navigate(crumb) : null"
    >{{ crumb.title }}</span>
  </ng-container>
  <app-novedades-plataforma></app-novedades-plataforma>
</div>
